import { request } from "./client";

const createIdempotencyKey = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const summarizeSessionResponse = (response) => {
  const data = response?.data || response;
  return {
    status: response?.status,
    hasData: !!data,
    onboardingSessionId: data?.onboarding_session_id,
    hasSessionToken: !!data?.session_token,
    expiresAt: data?.expires_at,
    hasLaunch: !!data?.launch,
    launchKeys: data?.launch ? Object.keys(data.launch) : [],
  };
};

const summarizeCompletePayload = (payload) => ({
  hasOnboardingSessionId: !!payload?.onboarding_session_id,
  hasSessionToken: !!payload?.session_token,
  hasAuthorizationCode: !!payload?.authorization_code,
  hasWabaId: !!payload?.session_info?.waba_id,
  hasPhoneNumberId: !!payload?.session_info?.phone_number_id,
  hasBusinessId: !!payload?.session_info?.business_id,
});

const summarizeErrorDetails = (error) => ({
  code: error?.details?.code || error?.details?.error_code || error?.details?.data?.code,
  hasDetails: !!error?.details,
  hasData: !!error?.details?.data,
  hasSessionToken: !!(error?.details?.session_token || error?.details?.data?.session_token),
  hasLaunch: !!(error?.details?.launch || error?.details?.data?.launch),
});

export const fetchWhatsAppOnboardingReadiness = async (tenantId) => {
  const endpoint = `/bots/${tenantId}/whatsapp/onboarding-readiness`;

  // console.log("[WhatsAppReadiness] request", {
  //   method: "GET",
  //   endpoint,
  //   tenantId,
  //   payload: null,
  // });

  try {
    const response = await request(endpoint, { skipCache: true });
    // console.log("[WhatsAppReadiness] response", response);
    return response;
  } catch (error) {
    // console.error("[WhatsAppReadiness] error", {
    //   status: error?.status,
    //   message: error?.message,
    //   details: summarizeErrorDetails(error),
    // });
    throw error;
  }
};

export const createWhatsAppOnboardingSession = async (tenantId, { restartExisting = false } = {}) => {
  const endpoint = `/bots/${tenantId}/whatsapp/onboarding-sessions`;
  const payload = { restart_existing: restartExisting };
  const idempotencyKey = createIdempotencyKey();

  // console.log("[WhatsAppOnboardingSession] request", {
  //   method: "POST",
  //   endpoint,
  //   tenantId,
  //   payload,
  //   idempotencyKey,
  //   hasIdempotencyKey: !!idempotencyKey,
  // });

  try {
    const response = await request(endpoint, {
      method: "POST",
      data: payload,
      headers: { "Idempotency-Key": idempotencyKey },
    });
    // console.log("[WhatsAppOnboardingSession] response", summarizeSessionResponse(response));

    return response;
  } catch (error) {
    // console.error("[WhatsAppOnboardingSession] error", {
    //   status: error?.status,
    //   message: error?.message,
    //   details: summarizeErrorDetails(error),
    // });

    throw error;
  }
};

export const fetchWhatsAppAccountStatus = async (tenantId) => {
  const endpoint = `/bots/${tenantId}/whatsapp/status`;

  try {
    const response = await request(endpoint, { skipCache: true });
    const data = response?.data?.data ?? response?.data ?? response;
    console.log(`[WhatsAppAccountStatus] GET ${endpoint} -> Status: "${data?.status}", Stage: "${data?.stage || "N/A"}"`, {
      status: data?.status,
      stage: data?.stage,
      message: data?.message,
      phone_number: data?.phone_number || data?.display_phone_number,
      available_actions: data?.available_actions,
    });
    return response;
  } catch (error) {
    console.error(`[WhatsAppAccountStatus] GET ${endpoint} Error:`, {
      status: error?.status,
      message: error?.message,
      error,
    });
    throw error;
  }
};

export const completeWhatsAppOnboarding = async (tenantId, payload) => {
  const endpoint = `/bots/${tenantId}/whatsapp/onboarding/complete`;

  // console.log("================================================================");
  // console.log("🚀 [DocLift WhatsApp Onboarding] STAGE 1: INITIATING ONBOARDING COMPLETION");
  // console.log("Tenant:", tenantId);
  // console.log("Endpoint: POST " + endpoint);
  // console.log("Mode:", payload?.mode || (payload?.session_info?.phone_number_id ? "standard" : "coexistence"));
  // console.log("Payload Summary:", {
  //   onboarding_session_id: payload?.onboarding_session_id,
  //   session_token: payload?.session_token ? `${payload.session_token.slice(0, 8)}...` : null,
  //   authorization_code: payload?.authorization_code ? `${payload.authorization_code.slice(0, 10)}...` : null,
  //   mode: payload?.mode,
  //   session_info: payload?.session_info,
  // });
  console.log("Full Payload:", payload);
  console.log("================================================================");

  try {
    const response = await request(endpoint, {
      method: "POST",
      data: payload,
    });
    const data = response?.data?.data ?? response?.data ?? response;

    // console.log("================================================================");
    // console.log("✅ [DocLift WhatsApp Onboarding] STAGE 2: ONBOARDING COMPLETION RESPONSE RECEIVED");
    // console.log("HTTP Status:", response?.status);
    // console.log("Account Status:", data?.status);
    // console.log("Pipeline Stage:", data?.stage);
    // console.log("Account ID:", data?.account_id || data?.waba_id);
    // console.log("Message:", data?.message);
    // console.log("Available Actions:", data?.available_actions);
    // console.log("Raw Response:", response);
    // console.log("================================================================");

    return response;
  } catch (error) {
    console.error("================================================================");
    console.error("❌ [DocLift WhatsApp Onboarding] STAGE 2: ONBOARDING COMPLETION API FAILED");
    console.error("HTTP Status:", error?.status);
    console.error("Error Message:", error?.message);
    console.error("Details:", error?.details || error?.response?.data);
    console.error("================================================================");

    throw error;
  }
};

export const retryWhatsAppOnboarding = async (tenantId) => {
  const endpoint = `/bots/${tenantId}/whatsapp/account/retry`;

  // console.log("[WhatsAppRetryOnboarding] request", {
  //   method: "POST",
  //   endpoint,
  //   tenantId,
  // });

  try {
    const response = await request(endpoint, {
      method: "POST",
    });
    // console.log("[WhatsAppRetryOnboarding] response", {
    //   status: response?.status,
    //   message: response?.message,
    //   accountStatus: response?.data?.data?.status,
    //   requestId: response?.data?.request_id,
    // });
    return response;
  } catch (error) {
    // console.error("[WhatsAppRetryOnboarding] error", {
    //   status: error?.status,
    //   message: error?.message,
    // });
    throw error;
  }
};
